import React from "react"

interface EmailProps {
  address: string
}
export const Email: React.FC<EmailProps> = props => (
  <a href={"mailto:" + props.address}>{props.children || props.address}</a>
)
